export default __webpack_public_path__ + "static/media/DanielCortild.edf2f67a.webp";